import * as types from '../constants/action.types';

export const scrollOutBanner = () => ({ type: types.SCROLL_OUT_BANNER });
export const scrollInBanner = () => ({ type: types.SCROLL_IN_BANNER });
